module.exports = __webpack_public_path__ + "media/cash.9ac27c60.mp3";